import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpErrorHandler {
  handleApiGateWayAnalyticsError(error: HttpErrorResponse) {
    if (error?.error?.error) {
      return throwError(error.error.error);
    }
    return throwError('An error occurred. Please try again.');
  }
}
